<template>
	<TeamingChip
		:class-name="classNames"
		:text="text"
		@click="$emit( 'click', $event )"
	>
		<template v-slot:icon>
			<FontAwesomeIcon :icon="['fas', 'exclamation-circle']" />
		</template>
	</TeamingChip>
</template>

<script>
import TeamingChip from "./TeamingChip";

export default {
	name: "WarningChip",
	emits: [
		"click",
	],
	components: {
		TeamingChip,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		text: {
			type: String,
			required: true,
		},
	},
	computed: {
		classes() {
			return {
				"warning-chip": true,
				[ this.className ]: !!this.className,
			};
		},
		classNames() {
			return Object.keys( this.classes )
				.filter( className => !!this.classes[ className ] )
				.join( " " );
		},
	},
};
</script>

<style lang="scss" scoped>
.teaming-chip.warning-chip {
	background-color: $warning-chip-background-color;
	display: inline-block;
	color: $warning-chip-color;
}
</style>
